import { ReaddirResult } from '@capacitor/filesystem';
import { IGetPathOpts, IPathKey } from '../../interfaces/services/filesystem/Paths';
import { getDirPath, PATHS_KEYS, getFilePath2 } from './getFilePath';
import {
    createDir,
    readDir,
    readFile,
    removeDir,
    removeFile,
    writeBlob,
    writeFile
} from './filesystem'
import { getInitialDirs, getUserDirs } from '../../consts/filesystem/PATHS.cts';

export class FileSystem {

    private userId?: number;

    constructor(){
    }

    async init(){

        const initialDirectories = getInitialDirs()
        for( let i = 0; i < initialDirectories.length; i++ ){
            await this.mkdir( initialDirectories[ i ] ).catch( console.error )
        }

    }

    async setUser( userId: number ){
        this.userId = userId;
        const userDirs = getUserDirs( userId )
        for(let i=0; i < userDirs.length; i++){
            await this.mkdir( userDirs[ i ] )
        }
    }

    async write( path: string, content: any, blob?: boolean ): Promise<void>{

        if ( !path ) throw new Error("Path param is required.");
        if ( !content ) throw new Error("Content param is required.");

        if ( blob === undefined || blob === false ){
            
            return writeFile( path, JSON.stringify(content) )

        } else if ( content instanceof Blob ) {

            return writeBlob( path, content )

        } else {
            throw new Error("Content is not Blob type");
        }

    }

    async read<T>( path: string ): Promise<T | undefined>{
        if ( !path ) throw new Error("Path param is required.");
        const content = await readFile(path);
        if ( content === '' ){
            return undefined
        } else {
            try {
                return JSON.parse( content )
            } catch (error) {
                return content as any
            }
        }
    }

    async mkdir( dirname: string, path?: string ): Promise<void>{
        if ( !dirname ) throw new Error("Path param is required.");
        try {
            await createDir(dirname, path)
        } catch (error) {
            console.error( error )
        }
    }

    async list( path: string ): Promise<ReaddirResult>{
        if ( !path ) throw new Error("Path param is required.");
        return readDir( path )
    }

    async removeDir( path: string ): Promise<void>{
        if ( !path ) throw new Error("Path param is required.");
        return removeDir( path )
    }

    async removeFile( path: string ): Promise<void>{
        if ( !path ) throw new Error("Path param is required.");
        return removeFile( path )
    }

    getPath( key: IPathKey, opts?: IGetPathOpts ): string {

        const pathKey = PATHS_KEYS.find( pk => pk.key === key )
        if ( pathKey !== undefined ){

            const isDirectory = typeof pathKey.isDirectory !== 'function' ? pathKey.isDirectory : pathKey.isDirectory( opts )
            if ( isDirectory ){
                return getDirPath( key, this.userId, opts )
            } else {
                return getFilePath2( key, this.userId, opts )
            }

        } else {
            throw new Error("Key path not found.");
        }

    }

}